import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import VpcBaseIndex from '../base/vpc/index.vue'
import * as _ from "lodash";
import whiteList from "../../service/common/whiteList";
import KpcViewTitle from "../../components/KpcViewTitle/index.vue";
import TableColumnEdit from "../../components/TableColumnEdit/index.vue";
import * as xlsxService from "../../service/common/xlsx";
import CopyIcon from "../../components/CopyIcon/index.vue";
import { Button, ButtonGroup } from 'kpc/components/button';
import { Dropdown, DropdownMenu, DropdownItem } from 'kpc/components/dropdown';
import Tooltip from 'kpc/components/tooltip';
import Icon from 'kpc/components/icon';
import apiRequest from '../../service/vpc/request';
import trustApiRequest from '../../service/trust_vpc/request';
import commonApiRequest from "../../service/common/apiRequest";
import { debounce } from "helpful-decorators";
import Message from "kpc/components/message";

import GroupBatchRemoveDialog from "../dialogs/batch-remove-group/index.vue";
import GroupBatchRemoveDialogType from "../dialogs/batch-remove-group/_vue";

Component.registerHooks([
    'beforeRouteEnter',
    'beforeRouteLeave',
    'beforeRouteUpdate',
]);
@Component({
    components: {
        KpcViewTitle,
        Button,
        Icon,
        Tooltip,
        Dropdown, DropdownMenu, DropdownItem,
        CopyIcon,
        TableColumnEdit,
        GroupBatchRemoveDialog,
    },
    mixins: [VpcBaseIndex]
})
export default class GroupView extends Vue {
    listColsFilterName = 'GroupListColsFilter';
    showExport = true;
    showAdvSearch = true; //是否显示高级搜索
    sgSupportCreate = true;
    userHasIpv6Quota = false;
    SecurityGroupTypeList = {
        default: this.$trans('默认安全组'),
        other: this.$trans('普通安全组'),
        global: this.$trans('全局安全组')
    }
    public beforeRouteEnter(to: any, from: any, next: any) {
        next((vm: any) => {
            if (!_.isEmpty(to.query)) {
                localStorage.vpcId = to.query.VpcId;
                localStorage.groupId = to.query.SecurityGroupId;

                //EPC来源
                if (!_.isEmpty(to.params) && to.query.epcsafe == '1') {
                    localStorage.vpcId = to.params.vpcId;
                    localStorage.groupId = to.params.secGroupId;
                }
            }
        })
    }

    public beforeRouteUpdate(to: any, from: any, next: any) {
        if (!_.isEmpty(to.query)) {
            localStorage.vpcId = to.query.VpcId;
            localStorage.groupId = to.query.SecurityGroupId;

            //EPC来源
            if (!_.isEmpty(to.params) && to.query.epcsafe == '1') {
                localStorage.vpcId = to.params.vpcId;
                localStorage.groupId = to.params.secGroupId;
            }
        }
        next();
    }
    
    get securityTypeGroup() {
        const typeList: any = [
            { label: this.$trans('全部'), value: '' },
            { label: this.$trans('普通安全组'), value: 'other' },
            { label: this.$trans('默认安全组'), value: 'default' }, 
        ];
        if(!this.isTrustVpc && this.allowGlobalSecGroup) {
            typeList.push({ label: this.$trans('全局安全组'), value: 'global' });
        }
        return typeList;
    }

    get request(){
        return this.isTrustVpc ? trustApiRequest : apiRequest
    }

    get regionSupport() {
        return this.isTrustVpc ? this.trustVpcQuota.value : true
    }

    @Watch('currentVpc', {
        deep: true
    })
    currentVpcWatcher() {
        this.getList(false);
    }

    rowKey(data: any) {
        return data.SecurityGroupId
    }

    getCheckedDetailList() {
        let me: any = this;
        let details: any[] = [];
        _.forEach(me.instanceList, item => {
            if (_.includes(me.instanceListOfChecked, item.SecurityGroupId)) {
                details.push(item);
            }
        });
        return details;
    }

    async open() {
        this.getList(false);
    }

    @debounce(200)
    async getList(regionChange: boolean = false) {
        let me: any = this;
        me.instanceList = [];
        me.instanceListOfChecked = [];
        me.instanceList = await me.loadList(regionChange);
        me.checkUserIpv6Quota();
        me.getSgSupportCreate();
    }

    @debounce(100)
    checkUserIpv6Quota() {
        let me: any = this;
        if (!me.region) {
            return;
        }
        apiRequest.CheckIPv6Quota({
            Region: me.region
        }).done((result: any) => {
            me.userHasIpv6Quota = result.Result;
        })
    }

    getSgSupportCreate() {
        let me: any = this;
        // 是否允许客户创建安全组。1、不允许；2、允许
        commonApiRequest.DescribeQuotaByName({
            Region: me.region,
            QuotaName: "quota_vpc_securitygroupon"
        })
        .done((data: any) => {
            if (data && data.QuotaMax) {
                this.sgSupportCreate = data.QuotaMax == 2 ? true : false;
            }
        });
    }

    getVpcName(id: any) {
        // if(id === "All") {
        //     return "All";
        // }
        let vpc = _.find(this.vpcList, function (item) {
            return item.VpcId == id;
        });
        return _.get(vpc, 'VpcName', '-');
    }

    remarksChangeHandler(scope: any, value: string) {
        value = _.trim(value);
        let remark = scope.Description;
        scope.Description = value;
        // apiRequest.ModifySecurityGroup({
        this.request.ModifySecurityGroup({
            Region: this.region,
            SecurityGroupId: scope.SecurityGroupId,
            Description: value
        }).done((data: any) => {
        }).fail(() => {
            scope.Description = remark;
        });
    }

    get listSearched() {
        let me: any = this;
        // let searchQuery = _.trim(me.searchQuery);
        let temp = _.trim(this.searchQuery);
        let splitData = temp.split("：");
        let searchQuery = splitData.length > 1 ? splitData[1] : splitData[0];
        if (!searchQuery) {
            return me.instanceList;
        }
        let searchQueryLowerCase = searchQuery.toLowerCase();

        return _.filter(me.instanceList, (item: any) => {
            if(me.showAdvSearch) {
                if (me.searchAttr == 'Group_name') {
                    return item.SecurityGroupName.toString().toLowerCase().includes(searchQueryLowerCase)
                } else if (me.searchAttr == 'Group_id') {
                    return item.SecurityGroupId.toString().toLowerCase().includes(searchQueryLowerCase)
                } else if (me.searchAttr == 'inRule_ip') {
                    if (item.SecurityGroupEntrySet && item.SecurityGroupEntrySet.length) {
                        return _.find(item.SecurityGroupEntrySet, (subitem) => {
                            return subitem.CidrBlock == searchQueryLowerCase && subitem.Direction == 'in';
                        })
                    }
                } else if (me.searchAttr == 'outRule_ip') {
                    if (item.SecurityGroupEntrySet && item.SecurityGroupEntrySet.length) {
                        return _.find(item.SecurityGroupEntrySet, (subitem) => {
                            return subitem.CidrBlock == searchQueryLowerCase && subitem.Direction == 'out';
                        })
                    }
                } else if (me.searchAttr == 'inRule_port') {
                    if (item.SecurityGroupEntrySet && item.SecurityGroupEntrySet.length) {
                        return _.find(item.SecurityGroupEntrySet, (subitem) => {
                            return subitem.PortRangeFrom <= _.toNumber(searchQueryLowerCase) && subitem.PortRangeTo >= _.toNumber(searchQueryLowerCase) && subitem.Direction == 'in';
                        })
                    }
                } else if (me.searchAttr == 'outRule_port') {
                    if (item.SecurityGroupEntrySet && item.SecurityGroupEntrySet.length) {
                        return _.find(item.SecurityGroupEntrySet, (subitem) => {
                            return subitem.PortRangeFrom <= _.toNumber(searchQueryLowerCase) && subitem.PortRangeTo >= _.toNumber(searchQueryLowerCase) && subitem.Direction == 'out';
                        })
                    }
                }
            }
            return item.SecurityGroupName.toString().toLowerCase().includes(searchQueryLowerCase) ||
                item.SecurityGroupId.toString().toLowerCase().includes(searchQueryLowerCase)
        })
    }   

    get exportListSupport():any {
        const me:any = this;
        return whiteList.check('exportRules', me.region);
    }

    get regionAvailable():any {
        const me:any = this;
        if (!me.region) {
            return true;
        }
        let type = "securityGroupsSearchSortExport";
        return whiteList.check(type, me.region);
    }

    get isShowDockerCount(){
        if (this.isTrustVpc) return false
        return this.showListColumn("DockerCount", this.$trans(`容器实例数量`), 80, false, true)
    }

    checkDnsState(row: any) {
        if(row.UserTag === "dns") {
            return {
                disabled: true,
                msg: this.$trans('已被转发Zone业务使用，不允许自行删除，请勿用做转发Zone以外的业务，删除出站VPC时会自动删除当前安全组。')
            };
        }
        return {
            disabled: false,
            msg: ''
        }
    }

    gotoEditRule(row: any, type: any) {
        let me: any = this;
        // let link = me.$router.resolve({
        //     name: 'groupEditRule',
        //     params: {
        //         type: type,
        //         region: me.region,
        //         vpcId: row.VpcId || "",
        //         groupId: row.SecurityGroupId || ""
        //     }
        // })
        // return link.href;
        // this.$router.push({
        //     name: 'groupEditRule',
        //     params: {
        //         type: type,
        //         region: me.region,
        //         vpcId: row.VpcId || "",
        //         groupId: row.SecurityGroupId || ""
        //     }
        // });
        this.$router.push({
            name: this.isTrustVpc ? 'trustGroupDetailInstance' : 'groupDetailInstance',
            params: {
                type,
                region: me.region,
                vpcId: row.VpcId || 0,
                groupId: row.SecurityGroupId || "",
                SecurityGroupType: row.SecurityGroupType
            }
        });
    }

    async exportList(type:string="") {
        const me:any = this;
        let list: any = _.cloneDeep(this.listSearched);
        if (this.instanceListOfChecked.length !== 0) {
            // 直接导出勾选的
            list = _.filter(list, item => {
                return _.includes(
                    this.instanceListOfChecked,
                    item.SecurityGroupId
                );
            });
        }
        if (list.length === 0) {
            Message.info(this.$trans("没有要导出的数据哦"));
            return;
        }
        if (type == 'rule') {
            let rows: any[] = [
                [
                    me.$trans(`安全组名称`),
                    me.$trans(`安全组ID`),
                    me.$trans(`VPCID`),
                    me.$trans("出入站"),
                    me.$trans("优先级"),
                    me.$trans("访问权限"),
                    me.$trans("协议"),
                    me.$trans(`起始端口`),
                    me.$trans(`结束端口`),
                    me.$trans("源/目的IP"),
                    me.$trans('创建时间'),
                    me.$trans("TAG"),
                    me.$trans('规则备注'),
                ]
            ];
            _.forEach(list, item => {
                if (item.SecurityGroupEntrySet && item.SecurityGroupEntrySet.length) {
                    item.SecurityGroupEntrySet.forEach((ele: any) => {
                        let startPort = "";
                        if (ele.Protocol == "ip") {
                            startPort = "-";
                        } else if (ele.Protocol == "icmp") {
                            // let IcmpType = _.find(me.IcmpTypeList, ['value', ele.IcmpType.toString()]);
                            // startPort = !_.isEmpty(IcmpType) ? IcmpType.title : '';
                            startPort = ele.IcmpType;
                        } else if (ele.Protocol == "tcp" || ele.Protocol == "udp") {
                            startPort = ele.PortRangeFrom;
                        } else if (ele.Protocol == "ping") {
                            startPort = "Echo";
                        } else if (ele.Protocol == "ssh") {
                            startPort = "22";
                        } else if (ele.Protocol == "http") {
                            startPort = "80";
                        } else if (ele.Protocol == "https") {
                            startPort = "443";
                        } else if (ele.Protocol == "openvpn") {
                            startPort = "1194";
                        } else if (ele.Protocol == "remote") {
                            startPort = "3389";
                        }

                        let endPort = "";
                        if (ele.Protocol == "ip") {
                            endPort = "-";
                        } else if (ele.Protocol == "icmp") {
                            endPort = ele.IcmpCode;
                        } else if (ele.Protocol == "tcp" || ele.Protocol == "udp") {
                            endPort = ele.PortRangeTo;
                        } else if (ele.Protocol == "ping") {
                            endPort = "Echo request";
                        } else if (ele.Protocol == "ssh") {
                            endPort = "22";
                        } else if (ele.Protocol == "http") {
                            endPort = "80";
                        } else if (ele.Protocol == "https") {
                            endPort = "443";
                        } else if (ele.Protocol == "openvpn") {
                            endPort = "1194";
                        } else if (ele.Protocol == "remote") {
                            endPort = "3389";
                        } else if (ele.Protocol == "healthy") {
                            endPort = "65535";
                        }
                        // let port;
                        // if(startPort == endPort) {
                        //     port = startPort;
                        // } else {
                        //     port = startPort + "-" + endPort;
                        // }
                        if(me.exportListSupport) {
                            rows.push([
                                item.SecurityGroupName,
                                item.SecurityGroupId,
                                item.SecurityGroupType === 'global' ? "ALL" : item.VpcId,
                                ele.Direction,
                                ele.Priority || '-',
                                ele.Policy == 'Accept' ? me.$trans("允许") : me.$trans("拒绝"),
                                ele.Protocol,
                                startPort,
                                endPort,
                                ele.CidrBlock,
                                ele.CreateTime,
                                ele.RuleTag,
                                ele.Description,
                            ]);
                        } else {
                            rows.push([
                                item.SecurityGroupName,
                                item.SecurityGroupId,
                                item.SecurityGroupType === 'global' ? "ALL" : item.VpcId,
                                ele.Direction,
                                '-',
                                ele.Policy == 'Accept' ? me.$trans("允许") : me.$trans("拒绝"),
                                ele.Protocol,
                                startPort,
                                endPort,
                                ele.CidrBlock,
                                ele.CreateTime,
                                ele.RuleTag,
                                ele.Description,
                            ]);
                        }
                    })
                }
                
            });
            xlsxService.download("secGroup-rules-list", rows);
        } else {
            let rows :any[] = []
            if (!this.isTrustVpc) {
                 rows = [
                    [
                        this.$trans(`名称`),
                        this.$trans("所属VPC"),
                        this.$trans("云服务器数量"),
                        this.$trans(`裸金属服务器数量`),
                        this.$trans("容器实例数量"),
                        this.$trans("入站规则数量"),
                        this.$trans("出站规则数量"),
                        this.$trans('备注'),
                        this.$trans('创建时间')
                    ]
                ];
                _.forEach(list, item => {
                    if(item.SecurityGroupType === 'global') {
                        rows.push([
                            item.SecurityGroupName,
                            "ALL",
                            item.InterfaceCount,
                            item.InterfaceEpcCount,
                            item.DockerCount,
                            item.SecurityGroupEntryCountIn,
                            item.SecurityGroupEntryCountOut,
                            item.Description,
                            item.CreateTime
                        ]);
                    } else {
                        rows.push([
                            item.SecurityGroupName,
                            item.SecurityGroupType === 'global' ? "ALL" : this.getVpcName(item.VpcId),
                            item.InterfaceCount,
                            item.InterfaceEpcCount,
                            item.DockerCount,
                            item.SecurityGroupEntryCountIn,
                            item.SecurityGroupEntryCountOut,
                            item.Description,
                            item.CreateTime
                        ]);
                    }
                });
            }else{
                rows = [
                    [
                        this.$trans(`名称`),
                        this.$trans("所属VPC"),
                        this.$trans("云服务器数量"),
                        this.$trans(`裸金属服务器数量`),
                        this.$trans("入站规则数量"),
                        this.$trans("出站规则数量"),
                        this.$trans('备注'),
                        this.$trans('创建时间')
                    ]
                ];
                _.forEach(list, item => {
                    rows.push([
                        item.SecurityGroupName,
                        item.SecurityGroupType === 'global' ? "ALL" : this.getVpcName(item.VpcId),
                        item.InterfaceCount,
                        item.InterfaceEpcCount,
                        item.SecurityGroupEntryCountIn,
                        item.SecurityGroupEntryCountOut,
                        item.Description,
                        item.CreateTime
                    ]);
                });
            }
            xlsxService.download("secGroup-list", rows);
        }
    }

    gotoCloneGroup(row: any) {
        let me: any = this;
        this.$router.push({
            name: me.isTrustVpc ? 'trustGroupCloneGroup' : 'groupCloneGroup',
            params: {
                type: 'inRule', //  此处需要修正
                region: me.region,
                vpcId: row.VpcId || 0,
                groupId: row.SecurityGroupId || "",
                SecurityGroupType: row.SecurityGroupType
            }
        });
    }

    gotoMangerServer(row: any, type: any) {
        let me: any = this;
        this.$router.push({
            name: me.isTrustVpc ? 'trustGroupMangerServer' : 'groupMangerServer',
            params: {
                type: type,
                region: me.region,
                vpcId: row.VpcId || 0,
                groupId: row.SecurityGroupId,
                groupName: encodeURIComponent(row.SecurityGroupName),
            }
        });
    }

    openBatchRemoveDialog(row: any) {
        let dialog: any = this.$refs.GroupBatchRemoveDialog as GroupBatchRemoveDialogType;
        let selectList: any[] = [];

        if (row && row.SecurityGroupId) {
            selectList = [row.SecurityGroupId];
        } else {
            selectList = this.instanceListOfChecked;
        }

        let groupList = _.map(selectList, (securityGroupId: string) => {
            return _.find(this.instanceList, ['SecurityGroupId', securityGroupId]);
        })

        dialog.open(this.region, groupList, () => {
            this.reload();
        })
    }

    createGroup() {
        this.$router.push({
            name: this.isTrustVpc ? 'trustGroupCreate' : 'groupCreate',
            params: {
                region: this.region,
            }
        });
    }

    groupNameChangeHandler(scope: any, value: string) {
        value = _.trim(value);
        let srcName = scope.SecurityGroupName;
        scope.SecurityGroupName = value;
        // apiRequest.ModifySecurityGroup({
        this.request.ModifySecurityGroup({
            Region: this.region,
            SecurityGroupId: scope.SecurityGroupId,
            SecurityGroupName: value
        }).done((data: any) => {
        }).fail(() => {
            scope.SecurityGroupName = srcName;
        });
    }

    // async doRemove(row: any) {
    //     return new Promise(resolve => {
    //         apiRequest.DeleteSecurityGroups({
    //             Region: this.region,
    //             ids: row.SecurityGroupId
    //         }).done((data: any) => {
    //             if (data && data.Return) {
    //                 Message.success(this.$trans(`删除成功`));
    //             }
    //         }).always(() => {
    //             this.reload();
    //         });
    //     });
    // }

    instanceDetailUrl(row: any, type: string) {
        let link = this.$router.resolve({
            name: this.isTrustVpc ? 'trustGroupDetailInstance' : 'groupDetailInstance',
            params: {
                type,
                region: this.region,
                vpcId: row.VpcId || 0,
                groupId: row.SecurityGroupId
            }
        })
        return link.href;
    }

    gotoVpcUrl(row: any) {
        // let link = this.$router.resolve({
        //     name: "vpcDetailInfo",
        //     params: {
        //         region: this.region,
        //         vpcId: row.VpcId
        //     }
        // });
        // return link.href;
        const indexPath = this.isTrustVpc ? 'trust-vpc' : 'vpc'
        return `//network.console.ksyun.com/v2/#/${indexPath}/index/search/${row.VpcId || 0}`;
    }

    detailUrl(row: any) {
        let me: any = this;
        let link = me.$router.resolve({
            // 互信vpc的判断呢
            name:  me.isTrustVpc ? 'trustGroupDetailInfo' : 'groupDetailInfo',
            params: {
                region: me.region,
                vpcId: row.VpcId || 0,
                groupId: row.SecurityGroupId,
            }
        })
        return link.href;
    }

    async loadList() {
        let me: any = this;
        me.instanceList = [];
        me.instanceListOfChecked = [];
        var vpcId = localStorage.vpcId;
        // let params: any = {
        //     'Region': me.region,
        //     MaxResults: 100
        // };

        let params: any = {};

        if (localStorage.safeVpcId) {
            if (localStorage.safeVpcId != me.currentVpc.vpcId) {
                me.super.changeVpc.call(this, localStorage.safeVpcId);
                params = {
                    "Region": me.region,
                    'Filter.1.Name': 'vpc-id',
                    'Filter.1.Value.1': localStorage.safeVpcId,
                    // MaxResults: 100
                }
            } else {
                params = {
                    "Region": me.region,
                    'Filter.1.Name': 'vpc-id',
                    'Filter.1.Value.1': vpcId,
                    // MaxResults: 100
                }
            }
        } else {
            if (me.currentVpc.vpcId == "all") {
                params = {
                    "Region": me.region,
                    // MaxResults: 100
                }
            } else {
                params = {
                    "Region": me.region,
                    'Filter.1.Name': 'vpc-id',
                    'Filter.1.Value.1': vpcId || 'all',
                    // MaxResults: 100
                }
            }
        }

        let SecurityGroupSet: any[] = await this.getSecGroupList(params);
        // SecurityGroupSet = _.get(res, 'SecurityGroupSet', []);
        if (!SecurityGroupSet) {
            return;
        }

        //提取入站和出站规则数据
        _.forEach(SecurityGroupSet, (item) => {
            let SecurityGroupEntrySet = _.get(item, 'SecurityGroupEntrySet', []);

            let inRuleList = [];
            let outRuleList = [];
            if (SecurityGroupEntrySet && SecurityGroupEntrySet.length) {
                _.forEach(SecurityGroupEntrySet, (subitem) => {
                    if (subitem.Direction == 'in') {
                        inRuleList.push(subitem);
                    }
                    if (subitem.Direction == 'out') {
                        outRuleList.push(subitem);
                    }
                });
            }

            item.SecurityGroupEntryCountIn = inRuleList.length;
            item.SecurityGroupEntryCountOut = outRuleList.length;
        });

        return SecurityGroupSet;
    }

    private async loopGetSetGroupList(params: any, nextToken: any, cache: any, cb: any, errCb: any) {
        const me = this;
        const Params = {
            ...params,
            MaxResults: 1000,
            NextToken: "",
        }
        cache = cache || [];

        if(nextToken) {
            Params.NextToken = nextToken;
        }

        this.request.DescribeSecurityGroups(Params).done((data: any) => {
            cache = cache.concat(data.SecurityGroupSet || []);

            if(data.NextToken) {
                me.loopGetSetGroupList(params, data.NextToken, cache, cb, errCb);
            } else {
                cb(cache);
            }
        }).fail(() => {
            errCb();
        });

    }

    private async getSecGroupList(params: any): Promise<any | null> {
        const me = this;
        return new Promise(resolve => {
            // apiRequest.DescribeSecurityGroups(params).done((data: any) => {
            me.loopGetSetGroupList(params, "", [], (val: any) => {
                resolve(val);
            }, () => {
                resolve([]);
            })
            // this.request.DescribeSecurityGroups(params).done((data: any) => {
            //     resolve(data);
            // }).fail(() => {
            //     resolve(null);
            // });
        })
    }
}
